<template>
  <div class="faq-page">
    <!-- Intro Section -->
    <section class="faq-intro position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="faq-intro-content text-center">
              <div class="faq-section-label">
                <h4>Frequently Asked</h4>
              </div>
              <div class="faq-main-title">
                <h2>Frequently Asked Questions</h2>
              </div>
              <div class="faq-description">
                <p>Find answers to common questions about our services, processes, and how we can help you achieve your technology goals.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Accordion Section -->
    <section class="faq-accordion position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>

      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="faq-accordion-container">
              <!-- Services FAQ -->
              <div class="faq-category">
                <h3>Services & Solutions</h3>
                <div class="faq-items">
                  <div class="faq-item" v-for="(item, index) in servicesFAQ" :key="'services-' + index">
                    <div class="faq-question" @click="toggleFAQ('services', index)">
                      <h4>{{ item.question }}</h4>
                      <div class="faq-icon" :class="{ 'active': activeFAQ.services === index }">
                        <i class="icon-02"></i>
                      </div>
                    </div>
                    <div class="faq-answer" :class="{ 'active': activeFAQ.services === index }">
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Process FAQ -->
              <div class="faq-category">
                <h3>Project Process</h3>
                <div class="faq-items">
                  <div class="faq-item" v-for="(item, index) in processFAQ" :key="'process-' + index">
                    <div class="faq-question" @click="toggleFAQ('process', index)">
                      <h4>{{ item.question }}</h4>
                      <div class="faq-icon" :class="{ 'active': activeFAQ.process === index }">
                        <i class="icon-02"></i>
                      </div>
                    </div>
                    <div class="faq-answer" :class="{ 'active': activeFAQ.process === index }">
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Technology FAQ -->
              <div class="faq-category">
                <h3>Technology & Stack</h3>
                <div class="faq-items">
                  <div class="faq-item" v-for="(item, index) in technologyFAQ" :key="'technology-' + index">
                    <div class="faq-question" @click="toggleFAQ('technology', index)">
                      <h4>{{ item.question }}</h4>
                      <div class="faq-icon" :class="{ 'active': activeFAQ.technology === index }">
                        <i class="icon-02"></i>
                      </div>
                    </div>
                    <div class="faq-answer" :class="{ 'active': activeFAQ.technology === index }">
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pricing FAQ -->
              <div class="faq-category">
                <h3>Pricing & Payment</h3>
                <div class="faq-items">
                  <div class="faq-item" v-for="(item, index) in pricingFAQ" :key="'pricing-' + index">
                    <div class="faq-question" @click="toggleFAQ('pricing', index)">
                      <h4>{{ item.question }}</h4>
                      <div class="faq-icon" :class="{ 'active': activeFAQ.pricing === index }">
                        <i class="icon-02"></i>
                      </div>
                    </div>
                    <div class="faq-answer" :class="{ 'active': activeFAQ.pricing === index }">
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Support FAQ -->
              <div class="faq-category">
                <h3>Support & Maintenance</h3>
                <div class="faq-items">
                  <div class="faq-item" v-for="(item, index) in supportFAQ" :key="'support-' + index">
                    <div class="faq-question" @click="toggleFAQ('support', index)">
                      <h4>{{ item.question }}</h4>
                      <div class="faq-icon" :class="{ 'active': activeFAQ.support === index }">
                        <i class="icon-02"></i>
                      </div>
                    </div>
                    <div class="faq-answer" :class="{ 'active': activeFAQ.support === index }">
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action Section -->
    <section class="faq-cta position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="cta-content text-center">
              <div class="cta-title">
                <h2>Still Have Questions?</h2>
              </div>
              <div class="cta-description">
                <p>Can't find the answer you're looking for? Our team is here to help. Get in touch with us for personalized assistance.</p>
              </div>
              <div class="cta-buttons">
                <router-link to="/contact" class="cta-btn primary-btn">
                  <i class="icon-02"></i> Contact Us
                </router-link>
                <a href="mailto:hello@sogdo.com" class="cta-btn secondary-btn">
                  <i class="icon-04"></i> Send Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import WOW from 'wowjs'

export default {
  name: 'FAQPage',
  setup() {
    const activeFAQ = ref({
      services: null,
      process: null,
      technology: null,
      pricing: null,
      support: null
    })

    const toggleFAQ = (category, index) => {
      if (activeFAQ.value[category] === index) {
        activeFAQ.value[category] = null
      } else {
        activeFAQ.value[category] = index
      }
    }

    const servicesFAQ = ref([
      {
        question: "What services do you offer?",
        answer: "We offer comprehensive technology services including web development, mobile app development, AI/ML solutions, blockchain development, cloud architecture, IoT solutions, and digital transformation consulting. Our services cover the entire technology stack from frontend to backend, and we specialize in modern frameworks and cutting-edge technologies."
      },
      {
        question: "Do you provide end-to-end development services?",
        answer: "Yes, we provide complete end-to-end development services. From initial concept and design to deployment and ongoing maintenance, we handle every aspect of your project. Our team includes designers, developers, DevOps engineers, and project managers to ensure seamless delivery."
      },
      {
        question: "Can you work with existing systems and integrate new solutions?",
        answer: "Absolutely! We specialize in integrating new solutions with existing systems. Our team has extensive experience in API development, system integration, data migration, and legacy system modernization. We ensure minimal disruption to your current operations while enhancing your capabilities."
      },
      {
        question: "Do you offer specialized services for specific industries?",
        answer: "Yes, we have expertise across various industries including healthcare, finance, e-commerce, education, manufacturing, and more. Our team understands industry-specific requirements, compliance standards, and best practices to deliver tailored solutions that meet your sector's unique needs."
      }
    ])

    const processFAQ = ref([
      {
        question: "How do you start a project?",
        answer: "Our project process begins with a discovery phase where we understand your requirements, goals, and constraints. We then create a detailed project plan, timeline, and budget. After approval, we move to design and development phases with regular check-ins and demos. We use agile methodologies to ensure flexibility and continuous improvement throughout the project."
      },
      {
        question: "What is your typical project timeline?",
        answer: "Project timelines vary based on complexity and scope. Simple websites typically take 2-4 weeks, while complex applications can take 3-6 months or more. We provide detailed timelines during the planning phase and keep you updated on progress throughout development. We also offer MVP (Minimum Viable Product) approaches for faster initial delivery."
      },
      {
        question: "How do you handle project communication and updates?",
        answer: "We maintain regular communication through scheduled meetings, progress reports, and real-time collaboration tools. You'll have a dedicated project manager and direct access to the development team. We use project management tools to track progress, share updates, and ensure transparency throughout the entire development process."
      },
      {
        question: "What happens after project completion?",
        answer: "After project completion, we provide comprehensive documentation, training sessions, and ongoing support options. We offer maintenance packages, monitoring services, and feature updates. Our team remains available for future enhancements, bug fixes, and scaling as your business grows."
      }
    ])

    const technologyFAQ = ref([
      {
        question: "What tech stacks do you use?",
        answer: "We work with a wide range of modern technologies including React, Vue.js, Angular for frontend; Node.js, Python, Java, .NET for backend; AWS, Azure, Google Cloud for cloud services; Docker, Kubernetes for containerization; PostgreSQL, MongoDB, MySQL for databases; and various AI/ML frameworks like TensorFlow, PyTorch. We choose the best technology stack based on your specific requirements."
      },
      {
        question: "Do you work with legacy systems and older technologies?",
        answer: "Yes, we have extensive experience working with legacy systems and can help modernize them. We support various legacy technologies and can create integration solutions that bridge old and new systems. Our approach focuses on gradual modernization to minimize risk while improving performance and maintainability."
      },
      {
        question: "How do you ensure code quality and security?",
        answer: "We follow industry best practices including code reviews, automated testing, security audits, and continuous integration. Our development process includes unit testing, integration testing, and security testing. We use tools like SonarQube for code quality analysis and implement security measures from the ground up."
      },
      {
        question: "Do you provide cloud solutions and DevOps services?",
        answer: "Yes, we offer comprehensive cloud solutions including infrastructure setup, deployment automation, monitoring, and scaling. Our DevOps services include CI/CD pipeline setup, container orchestration, infrastructure as code, and 24/7 monitoring. We work with all major cloud providers and can help optimize your cloud costs and performance."
      }
    ])

    const pricingFAQ = ref([
      {
        question: "How do you price your projects?",
        answer: "We offer flexible pricing models including fixed-price projects, time and materials, and retainer agreements. Pricing depends on project complexity, timeline, and specific requirements. We provide detailed quotes after understanding your needs and can work within your budget constraints while ensuring quality delivery."
      },
      {
        question: "Do you offer maintenance and support packages?",
        answer: "Yes, we offer various maintenance and support packages ranging from basic monitoring to comprehensive support including updates, security patches, and feature enhancements. Our packages are designed to fit different needs and budgets, ensuring your systems remain secure, updated, and performing optimally."
      },
      {
        question: "What payment terms do you offer?",
        answer: "We offer flexible payment terms including milestone-based payments, monthly retainers, and custom payment schedules. For larger projects, we typically require an initial deposit with payments tied to project milestones. We're happy to discuss payment terms that work best for your business."
      },
      {
        question: "Do you provide cost estimates before starting a project?",
        answer: "Yes, we provide detailed cost estimates and project proposals before starting any work. Our estimates include development costs, timeline, and any additional services. We're transparent about pricing and will work with you to find the best solution within your budget."
      }
    ])

    const supportFAQ = ref([
      {
        question: "What kind of support do you provide after project completion?",
        answer: "We provide comprehensive post-launch support including bug fixes, performance optimization, security updates, and feature enhancements. Our support includes 24/7 monitoring, regular backups, and emergency response. We also offer training sessions for your team to manage the system effectively."
      },
      {
        question: "How quickly do you respond to support requests?",
        answer: "Our response times vary based on the support package: Critical issues (P1) are addressed within 2 hours, High priority (P2) within 24 hours, and Medium priority (P3) within 48 hours. We have dedicated support teams and escalation procedures to ensure timely resolution of all issues."
      },
      {
        question: "Do you provide training for our team?",
        answer: "Yes, we provide comprehensive training programs for your team including system administration, content management, and basic troubleshooting. Training can be conducted on-site, remotely, or through recorded sessions. We also provide detailed documentation and ongoing support to ensure your team can effectively manage the system."
      },
      {
        question: "What happens if we need to scale or add new features?",
        answer: "We design all our solutions with scalability in mind. When you need to scale or add new features, we can quickly implement changes and enhancements. Our team is familiar with your system architecture and can efficiently add new functionality while maintaining system stability and performance."
      }
    ])

    onMounted(() => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false
      }).init()
    })

    return {
      activeFAQ,
      toggleFAQ,
      servicesFAQ,
      processFAQ,
      technologyFAQ,
      pricingFAQ,
      supportFAQ
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Global Styles */
body {
  font-family: 'Open Sans', sans-serif;
  line-height: 1.6;
  color: #333;
}

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Intro Section */
.faq-intro {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.faq-intro-content {
  position: relative;
  z-index: 2;
}

.faq-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.faq-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.faq-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

/* FAQ Accordion Section */
.faq-accordion {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.faq-accordion-container {
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
}

.faq-category {
  margin-bottom: 50px;
}

.faq-category h3 {
  font-size: 28px;
  font-weight: 600;
  color: #F6EC4F;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
  text-align: center;
}

.faq-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.faq-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  border-color: rgba(246, 236, 79, 0.3);
  box-shadow: 0 5px 15px rgba(246, 236, 79, 0.1);
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.faq-question:hover {
  background: rgba(246, 236, 79, 0.05);
}

.faq-question h4 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  font-family: 'Archivo', sans-serif;
  flex: 1;
  padding-right: 20px;
}

.faq-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.faq-icon i {
  font-size: 16px;
  color: #00061A;
  transition: transform 0.3s ease;
}

.faq-icon.active {
  transform: rotate(45deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.02);
}

.faq-answer.active {
  max-height: 500px;
  padding: 0 30px 25px;
}

.faq-answer p {
  font-size: 16px;
  color: #fff;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Call to Action Section */
.faq-cta {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description p {
  font-size: 18px;
  color: #fff;
  max-width: 600px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.primary-btn {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

.secondary-btn {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
}

.secondary-btn:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 767px) {
  .faq-main-title h2,
  .cta-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .faq-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .faq-question {
    padding: 20px;
  }
  
  .faq-question h4 {
    font-size: 16px;
    padding-right: 15px;
  }
  
  .faq-icon {
    width: 35px;
    height: 35px;
  }
  
  .faq-icon i {
    font-size: 14px;
  }
  
  .faq-answer.active {
    padding: 0 20px 20px;
  }
  
  .faq-category h3 {
    font-size: 24px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .faq-main-title h2,
  .cta-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .faq-question {
    padding: 15px;
  }
  
  .faq-answer.active {
    padding: 0 15px 15px;
  }
}
</style>